import { useLayoutEffect } from 'react';
import { useRouter } from '@atlassian/react-resource-router';
import { useAtlassianNavigationEnd } from '../../controllers/atlassian-navigation-end/index.tsx';

export const NavigationRouterListener = () => {
	const [{ route, location, match }] = useRouter();
	const onEnd = useAtlassianNavigationEnd();

	useLayoutEffect(() => {
		onEnd();
	}, [route, match, location, onEnd]);

	return null;
};
